import { render, staticRenderFns } from "./checkbox-text.vue?vue&type=template&id=9a4c818a&scoped=true&"
import script from "./checkbox-text.vue?vue&type=script&lang=ts&"
export * from "./checkbox-text.vue?vue&type=script&lang=ts&"
import style0 from "./checkbox-text.vue?vue&type=style&index=0&id=9a4c818a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4c818a",
  null
  
)

export default component.exports